module.exports = __webpack_public_path__ + "img/g11.0e45bc20.png";